module.exports = __webpack_public_path__ + "static/media/55_000066.7dc9b5cc.jpg";